<template>
  <div>
    <breadcrumb-bar :crumbs="[{name:'Groups'},{name:'Messaging'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <span class="caption-subject bold uppercase">Messaging</span>
                </div>
              </div>
              <div class="portlet-body">
                <ul class="list-group">
                  <li class="list-group-item">
                    <h4 class="pull-left">Send a Message</h4>
                    <router-link :to="{ name: 'Send Message' }" tag="button" class="btn green pull-right">
                      <i class="fa fa-check-square-o" aria-hidden="true"></i>
                      Continue
                    </router-link>
                    <div class="clearfix"></div>
                  </li>
                  <li class="list-group-item">
                    <h4 class="pull-left">Message History</h4>
                    <router-link :to="{ name: 'Message History' }" tag="button" class="btn green pull-right">
                      <i class="fa fa-check-square-o" aria-hidden="true"></i>
                      Continue
                    </router-link>
                    <div class="clearfix"></div>
                  </li>
                </ul>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs'
    import Spinner from '@/components/Spinner'
    import VueFormRender from '@/components/formbuilder/VueFormRender'

    export default {
        data() {
            return {}
        },
        components: {
            'breadcrumb-bar': Breadcrumbs,
            'vue-spinner': Spinner,
            'vue-form-render': VueFormRender,
        }
    }
</script>

<style scoped>
  .list-group-item {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?51fbaf90